import { useEffect } from "react";

/**
 * Ensure the current page is not indexed by search engines.
 * Adds <meta name="robots" content="noindex, nofollow"> to <head>
 * and cleans up when the component unmounts.
 */
export default function useNoIndex() {
  useEffect(() => {
    const existing = document.querySelector('meta[name="robots"]');
    const prev = existing?.getAttribute("content");
    const tag = existing || document.createElement("meta");
    tag.setAttribute("name", "robots");
    tag.setAttribute("content", "noindex, nofollow");
    if (!existing) document.head.appendChild(tag);
    return () => {
      if (existing && prev !== null) {
        existing.setAttribute("content", prev);
      } else {
        tag.remove();
      }
    };
  }, []);
}
